import esocialMetadata from './data/metadata.json';
import type { EsocialDataVersion } from './types.js';

export const ESOCIAL_DATA_VERSION: EsocialDataVersion = esocialMetadata as EsocialDataVersion;
